exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect__option--highlight::after {\n    background: #007AC9 !important;\n}\n.multiselect__option--highlight {\n    background: #007AC9 !important;\n}\n.multiselect__tag {\n    background: #007AC9 !important;\n}\n.multiselect__tag-icon::after {\n    color: #007AC9;\n}\n.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {\n    background: #007AC9;\n}\n\n", ""]);

// exports
